export default ({ IDL }) => {
  const Balance_2 = IDL.Nat;
  const Balance = Balance_2;
  const AccountIdentifier_2 = IDL.Text;
  const AccountIdentifier = AccountIdentifier_2;
  const TokenIdentifier_2 = IDL.Text;
  const Result_2 = IDL.Variant({
    'ok' : Balance_2,
    'err' : IDL.Variant({
      'CannotNotify' : AccountIdentifier,
      'InsufficientBalance' : IDL.Null,
      'InvalidToken' : TokenIdentifier_2,
      'Rejected' : IDL.Null,
      'Unauthorized' : AccountIdentifier,
      'Other' : IDL.Text,
    }),
  });
  const TransferResponse_2 = Result_2;
  const TransferResponse = TransferResponse_2;
  const Result = IDL.Variant({ 'ok' : TransferResponse, 'err' : IDL.Text });
  const TokenIdentifier = TokenIdentifier_2;
  const User_2 = IDL.Variant({
    'principal' : IDL.Principal,
    'address' : AccountIdentifier,
  });
  const User = User_2;
  const Memo_2 = IDL.Vec(IDL.Nat8);
  const Memo = Memo_2;
  return IDL.Service({
    'applicants' : IDL.Func([], [IDL.Vec(IDL.Principal)], ['query']),
    'available' : IDL.Func([], [Balance], ['query']),
    'draw_many' : IDL.Func([IDL.Text], [Result], []),
    'empty' : IDL.Func([], [], []),
    'tokenTransferNotification' : IDL.Func(
        [TokenIdentifier, User, Balance, Memo],
        [IDL.Opt(Balance)],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };